import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight, HeartHandshake } from "lucide-react";
export default function OurClinicalVision() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="23588" id="the-cpap-alternative" className="light bg-background text-foreground relative py-24 md:py-32 lg:py-40 overflow-hidden">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1612048/img/abstract_enamel_pattern.png" alt="Custom-fitted medical grade oral appliance for sleep apnea" className="w-full h-full object-cover opacity-15 mix-blend-overlay" />
        {}
        <div className="absolute inset-0 bg-gradient-to-b from-background via-background/90 to-background" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--secondary)_0%,_transparent_70%)] opacity-10" />
      </div>

      <div ref={ref} className={`relative z-10 max-w-4xl mx-auto px-6 flex flex-col items-center text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        {}
        <div className="mb-8 p-3 rounded-full bg-secondary/10 text-secondary border border-secondary/20 backdrop-blur-sm">
          <HeartHandshake className="w-8 h-8" strokeWidth={1.5} />
        </div>

        {}
        <h1 className="font-sans text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight mb-10 text-foreground leading-[1.1]">
          A Better Night’s Sleep <br className="hidden md:block" />
          Starts with a <span className="text-secondary italic">Custom Fit</span>
        </h1>

        {}
        <div className="space-y-8 text-lg md:text-xl leading-relaxed text-muted-foreground font-light max-w-3xl">
          <p>
            Tired of struggling with a bulky CPAP mask? Our oral appliance therapy 
            offers a clinically proven, comfortable alternative that fits 
            seamlessly into your life. We specialize in precision-crafted 
            devices that gently stabilize your airway while you sleep.
          </p>
          <p>
            By combining advanced digital imaging with medical-grade materials, 
            we create a solution that is uniquely yours. No noise, no hoses—just 
            restorative rest and the energy you need to reclaim your mornings 
            and protect your long-term health.
          </p>
          <p className="font-medium text-foreground/90">
            Experience the gold standard in sleep apnea care, delivered with a 
            focus on your total well-being and clinical excellence.
          </p>
        </div>

        {}
        <div className="mt-14 flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
          <Button asChild size="lg" className="rounded-xl text-base px-8 h-12 bg-secondary text-secondary-foreground shadow-lg shadow-secondary/20 hover:shadow-secondary/30 transition-all duration-300">
            <Link to="#">
              Book Free Consultation <ArrowRight className="ml-2 w-4 h-4" />
            </Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="rounded-xl text-base px-8 h-12 border-secondary/20 text-secondary hover:bg-secondary/10 hover:text-secondary hover:border-secondary/40 transition-all duration-300 bg-transparent">
            <Link to="/OralAppliancesPage">Explore Oral Appliances</Link>
          </Button>
        </div>
      </div>
    </section>;
}